import { FileText } from 'lucide-react'
import { AttachmentStub } from '../../components/chat/attachments/attachment-stub'

/** The desktop `files` toolset's `view` tool, by the name the backend gives client tools. */
export const VIEW_FILES_TOOL_NAME = 'client_files_view'

interface ViewedFile {
  fileId: string
  name?: string
  mimeType: string
}

/** The files a `view` result lists under `_files`, skipping any entry that isn't one. */
export function parseViewedFiles(result: unknown): Array<ViewedFile> {
  const files = (result as { _files?: unknown } | null)?._files
  if (!Array.isArray(files)) {
    return []
  }
  return files.filter(
    (file): file is ViewedFile =>
      typeof file?.fileId === 'string' &&
      typeof file?.mimeType === 'string' &&
      (file.name === undefined || typeof file.name === 'string'),
  )
}

export function ViewedFilesTool({ files }: { files: Array<ViewedFile> }) {
  if (files.length === 0) {
    return null
  }
  return (
    <div className="flex flex-wrap gap-1.5 py-1">
      {files.map((file) =>
        file.mimeType.startsWith('image/') ? (
          <AttachmentStub key={file.fileId} label={file.name ?? 'Image'} image={file.fileId} />
        ) : (
          <AttachmentStub key={file.fileId} label={file.name ?? 'PDF'} icon={<FileText size={16} />} />
        ),
      )}
    </div>
  )
}
